import { CheckIconSvg } from "components/icons/CheckIconSvg";
import Select, {
  GroupTypeBase,
  OptionProps,
  OptionTypeBase,
  Props,
  components,
} from "react-select";
import { colors } from "styles/variables";

export function CustomSelect<
  Option extends OptionTypeBase,
  IsMulti extends boolean = false,
  Group extends GroupTypeBase<Option> = GroupTypeBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  return (
    <Select
      components={{ Option }}
      styles={{
        control: (styles, { isFocused }) => ({
          ...styles,
          minHeight: 48,
          borderRadius: 6,
          boxShadow: "none",
          borderColor: isFocused ? colors.primaryFreshBlue : colors.shade200,
          "&:hover": {
            borderColor: colors.primaryFreshBlue,
            boxShadow: "none",
          },
        }),
        indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
        option: (styles, { isSelected, isFocused }) => ({
          ...styles,
          padding: "8px 16px",
          backgroundColor: isSelected
            ? colors.secondaryDeeperSand
            : colors.white,
          color: colors.primaryDeepBlue,
          "&:hover": {
            backgroundColor: colors.shade200,
          },
          "& > span": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          },
          "& svg": {
            stroke: colors.primaryDeepBlue,
            fill: colors.primaryDeepBlue,
          },
        }),
      }}
      {...props}
    />
  );
}

function Option<
  Option extends OptionTypeBase,
  IsMulti extends boolean = false,
  Group extends GroupTypeBase<Option> = GroupTypeBase<Option>,
>({ children, ...props }: OptionProps<Option, IsMulti, Group>) {
  return (
    <components.Option {...props}>
      <span {...props.data}>
        <span>{props.label}</span>
        {props.isSelected && <CheckIconSvg />}
      </span>
    </components.Option>
  );
}
